module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/arrow-em_secondary_hover-2d228c225f4c7fff5765bdc4039a8607.svg";